import { ChatAnswerDataMapper, ChatHistoryDataMapper } from 'modules/chat/domain/data-mappers';
import { CHAT_HISTORY_WINDOW } from 'modules/chat/domain/constants';
import { ChatAnswer, ChatAnswerDto, ChatHistoryDto, ChatMessage, SendChatMessagePayload } from 'modules/chat/domain/interfaces';
import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';

class ChatResource extends Resource {
  private readonly answerMapper = new ChatAnswerDataMapper();
  private readonly historyMapper = new ChatHistoryDataMapper();

  constructor() {
    super('chat', httpResource);
  }

  public async sendMessage(tournamentId: number, payload: SendChatMessagePayload): Promise<ChatAnswer> {
    const dto = await this.post<ChatAnswerDto>({ ...payload, tournamentId });

    return this.answerMapper.decode(dto);
  }

  public async getHistory(tournamentId: number, limit = CHAT_HISTORY_WINDOW): Promise<ChatMessage[]> {
    const dto = await this.child('history').get<ChatHistoryDto>({ tournamentId, limit });

    return this.historyMapper.decode(dto);
  }

  public async clearHistory(tournamentId: number): Promise<void> {
    await this.child('history').delete<void>((url) => `${url}?tournamentId=${tournamentId}`);
  }
}

const chatResource = new ChatResource();
export default chatResource;
